import apiClient from '../../../services/apiClient';
import store from "@/store/store";

export default {
	namespaced: true,
	state: {
		modulePools: null,
		init: null,
	},
	getters: {
		modulePools(state) {
			return state.modulePools;
		},
		active(state) {
			return state.modulePools.active;
		},
	},
	mutations: {
		SET_MODULE_POOLS(state, modulePools) {
			state.modulePools = modulePools
		},
		CLEAR_STORE(state) {
			state.init = null;
			state.modulePools = null;
		}
	},
	actions: {
		async init({commit}, state) {
			if (!this.state.init) {
				await apiClient.get('modules/stockpool/get').then(res => {
					commit('SET_MODULE_POOLS', res.data);
					console.log(res.data);
					this.state.init = true;
				}).catch(err => {
				})
			}
		},
		activate({commit}) {
			return store.dispatch('pools/moduleUpdate', {active: 1});
		},
		deactivate({commit}) {
			return store.dispatch('pools/moduleUpdate', {active: 0});
		},
		moduleUpdate({commit}, params) {
			return new Promise((resolve, reject) => {
				apiClient.put('modules/stockpool/update', params).then(res => {
					commit('SET_MODULE_POOLS', res.data);

					store.dispatch('dashboard/refresh');

					resolve(res.data);
				}).catch(err => {
					reject(err);
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
